var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg_color"},[_c('top-header',{attrs:{"type":6,"placeholder":'活动流程',"hasBorder":true,"bgColor":'#fff',"fontSize":"0.32rem"}}),_c('img',{attrs:{"src":require("@/assets/img/strictSelection/liucheng.jpg"),"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }